import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { BulkActionFormComponent } from '../MonitoringBulkActionDialog/bulk-action-form.component';
import { SentimentModel } from '../../models/sentiment.model';
import { SearchCriteriaQuerySentimentsEnum } from '../../../../api/mentions/enum/search-criteria-query-sentiments.enum';

@Component({
    selector: 'agpr-bulk-action-form-sentiment',
    templateUrl: './bulk-action-form-sentiment.component.html',
    styleUrls: ['./bulk-action-form-sentiment.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => BulkActionFormSentimentComponent),
            multi: true
        }],
    standalone: false
})
export class BulkActionFormSentimentComponent extends BulkActionFormComponent implements ControlValueAccessor {
    // TODO: localize?
    public sentiments = [
        new SentimentModel(SearchCriteriaQuerySentimentsEnum.positive),
        new SentimentModel(SearchCriteriaQuerySentimentsEnum.neutral),
        new SentimentModel(SearchCriteriaQuerySentimentsEnum.negative),
        new SentimentModel(SearchCriteriaQuerySentimentsEnum.notAvailable),
    ];
    public selectedSentiment = null;

    writeValue(newSentiment: SentimentModel): void {
        if (!newSentiment) {
            this.selectedSentiment = null;
        } else {
            const option = this.sentiments.find(sentiment => sentiment.id === newSentiment.id);
            if (option) {
                this.selectedSentiment = option;
            } else {
                this.selectedSentiment = null;
            }
        }
        this.changed();
    }
    changed(): void {
        this.onModelChange(this.selectedSentiment);
    }
}
